import gql from 'graphql-tag';
import { FUNDING_OPTIONS_FRAGMENT } from '../fragments/fundingOptions.gql';

export const CLEAR_REAL_TIME_BALANCE_CONTINGENCY_MUTATION = gql`
  ${FUNDING_OPTIONS_FRAGMENT}
  mutation ClearRealTimeBalanceContingency($bankId: String!, $token: String!) {
    clearRealTimeBalanceContingency(token: $token, bankId: $bankId) {
      ...fundingOptions
      disallowedInstruments {
        id
        reason
      }
    }
  }
`;
